import React from 'react';
import PropTypes from 'prop-types';

import Card from 'relements/build/esm/ui/card';
import Box from 'relements/build/esm/ui/box';
import Text from 'relements/build/esm/ui/text';
import Avatar from 'relements/build/esm/ui/avatar';

import Tick from '@src/containers/AgentEscalation/assets/tick.svg';
import Edit from '@src/containers/AgentEscalation/assets/edit.svg';
import { useInitials } from '@src/hooks';
import { formatDate } from './utils';

import {
  Container,
  Row,
  Column,
  ContentBox,
  IconButton,
  SvgIcon,
  LinkBox,
  Link,
} from './styledComponents';

function ActiveTool({
  name,
  iconUrl,
  lastEdited,
  toolDocUrl,
  contactUsDocUrl,
  onEdit,
}) {
  const initials = useInitials(name);

  return (
    <Container>
      <Card heading="Active Tools" padding="zero">
        <Row>
          <Column>
            <Text variant="h4.semi-bold" color="grey.dark">
              Tool name
            </Text>
            <ContentBox>
              <Avatar url={iconUrl} initials={initials} marginRight="xs" />
              <Text variant="h4.semi-bold" color="black.haptik">
                {name}
              </Text>
            </ContentBox>
          </Column>
          <Column marginLeft="45px">
            <Text variant="h4.semi-bold" color="grey.dark">
              Last edited
            </Text>
            <ContentBox>
              <Text variant="h4.semi-bold" color="black.haptik">
                {formatDate(lastEdited)}
              </Text>
            </ContentBox>
          </Column>
          <Box padding="zero" alignItems="center" marginLeft="auto">
            <SvgIcon src={Tick} height="13px" width="16px" />
            <Text variant="h3.semi-bold" color="green.haptik">
              Configured
            </Text>
          </Box>
          <Column marginLeft="20px">
            <IconButton themed variant="secondary" onClick={onEdit}>
              <SvgIcon src={Edit} height="11px" width="11px" />
              Edit
            </IconButton>
          </Column>
        </Row>
      </Card>
      <LinkBox>
        <Text variant="body.lg" color="black.haptik">
          If this configuration is still not working for you, &nbsp;
        </Text>
        <Link href={toolDocUrl} target="_blank">
          <Text
            variant="body.lg"
            color="yellow.haptik"
            borderBottom="1px solid #F6A400"
          >
            Visit&nbsp;
            {name}
            &nbsp;docs
          </Text>
        </Link>
        <Text variant="body.lg" color="yellow.haptik">
          &nbsp; or&nbsp;
        </Text>
        <Link href={contactUsDocUrl} target="_blank">
          <Text
            variant="body.lg"
            color="yellow.haptik"
            borderBottom="1px solid #F6A400"
          >
            contact support team
          </Text>
        </Link>
      </LinkBox>
    </Container>
  );
}

ActiveTool.propTypes = {
  name: PropTypes.string,
  iconUrl: PropTypes.string,
  lastEdited: PropTypes.string,
  toolDocUrl: PropTypes.string,
  contactUsDocUrl: PropTypes.string,
  onEdit: PropTypes.func.isRequired,
};

ActiveTool.defaultProps = {
  name: '',
  iconUrl: '',
  lastEdited: '',
  toolDocUrl: '',
  contactUsDocUrl: '',
};

export default React.memo(ActiveTool);
